import cx from 'classnames';
import styles from './Typography.module.scss';

export type TypographyTypes =
  | 'ticket-h1'
  | 'ticket-h2'
  | 'ticket-h3'
  | 'h0'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'main'
  | 'main2'
  | 'description'
  | 'description2'
  | 'addition'
  | 'addition2'
  | 'addition3'
  | 'h2-regular';

export type TypographyVariants =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'quaternary'
  | 'disabled'
  | 'error'
  | 'ironColor'
  | 'bronzeColor'
  | 'silverColor'
  | 'gold'
  | 'white-gold'
  | 'pink-gold'
  | 'red-gold'
  | 'Platinum';

interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  fontSize?: number;
  component: TypographyTypes;
  textTransform?: 'uppercase' | 'capitalize';
  variant?: TypographyVariants;
}

export const Typography: React.FC<TypographyProps> = ({
  component,
  children,
  className,
  fontSize,
  textTransform,
  variant = 'primary',
  ...props
}) => {
  const typographyClassName = cx(
    styles[variant],
    styles[component],
    textTransform ? styles[textTransform] : '',
    className,
  );

  return (
    <div className={typographyClassName} style={{ fontSize }} {...props}>
      {children}
    </div>
  );
};
